require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-warn-your-users-of-a-dangerous-action-with-btn-danger.json") })
        }
      }, "path---front-end-libraries-bootstrap-warn-your-users-of-a-dangerous-action-with-btn-danger");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-warn-your-users-of-a-dangerous-action-with-btn-danger!./.cache/json/front-end-libraries-bootstrap-warn-your-users-of-a-dangerous-action-with-btn-danger.json
// module id = 2024
// module chunks = 231608221292675